<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/* global echarts */
// require('echarts/theme/macarons') // echarts theme
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    location: {
      type: String,
      default: ''
    },
    chartTitle: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '1.8229rem'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'month'
    }
  },
  data () {
    return {
      chart: null,
      colors: ['#3888fa', '#f93996'],
      areaColors: ['rgba(64,158,255,0.3)', 'rgba(249,57,150,0.1)']
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.chart.dispose()
        this.$nextTick(() => {
          this.initChart()
        })
        // this.setOptions(val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions (data) {
      var series = []
      for (let i in data.series) {
        series.push(
          {
            name: data.series[i].title,
            smooth: true,
            type: 'line',
            itemStyle: {
              normal: {
                color: this.colors[i],
                lineStyle: {
                  color: this.colors[i],
                  width: 2
                },
                areaStyle: {
                  color: this.areaColors[i]
                }
              }
            },
            data: data.series[i].statistics,
            animationDuration: 2800,
            animationEasing: 'quadraticOut'
          }
        )
      }
      this.chart.setOption({
        title: {
          text: this.location + this.chartTitle,
          x:"left",    // 'left' | 'right' | 'center' | '100px'
	        y:"4%",     // 'top' | 'bottom' | 'center' | '100px'

    
          left: 'center',
          top: 5,
          textStyle: {
            color: '#ffffff',
            fontWeight: "normal",
            fontFamily: "sans-serif", // 主标题文字的字体系列。
            fontSize:"0.0938rem", // 字体大小
      lineHeight: "200", // 行高
      textBorderColor: "#3274a6", // 文字本身的描边颜色。
      textBorderWidth:3, // 文字本身的描边宽度。
      textShadowColor: "#232584", // 文字本身的阴影颜色。
      textShadowBlur: 3, // 文字本身的阴影长度。
      textShadowOffsetX: 3, // 文字本身的阴影 X 偏移。
      textShadowOffsetY: 3, //  文字本身的阴影 Y 偏移
          }
        },
        xAxis: {
          triggerEvent: true,
          data: data.xAxis,
          boundaryGap: false,
          nameLocation: 'middle',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }
        },
        grid: {
          left: 10,
          right: this.mode === 'month' ? 26 : 30,
          bottom: 20,
          top: 50,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }
        },
        series: series
      })
      this.chart.on('click', (param) => {
        console.log(param)
        if (param.componentType === 'xAxis') {
          this.$emit('xAxisClicked', param.value)
        } else {
          this.$emit('xAxisClicked', param.name)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index/LineBarChart.vue